<template>
  <VTooltip
    :open-delay="openDelay"
    :max-width="maxWidth"
    :open-on-hover="openOnHover"
    :open-on-click="openOnClick"
    :location="location"
    :disabled="disabled"
  >
    <template #activator="data">
      <slot name="activator" v-bind="data"></slot>
    </template>
    <template #default>
      <slot />
    </template>
  </VTooltip>
</template>

<script setup lang="ts">
import { VTooltip } from 'vuetify/components/VTooltip';
import { type Anchor } from '~/ui/UiTooltip/types.d';

export interface Props {
  openDelay?: string | number;
  maxWidth?: string | number;
  openOnHover?: boolean;
  openOnClick?: boolean;
  location?: Anchor;
  disabled?: boolean;
}

withDefaults(defineProps<Props>(), {
  openDelay: 300,
  maxWidth: 430,
  openOnHover: true,
  openOnClick: false,
  location: 'bottom',
  disabled: undefined,
});
</script>

<style lang="scss" scoped>
:deep(.v-overlay__content) {
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
}
</style>
